import { render, staticRenderFns } from "./ReportSectionLayout.vue?vue&type=template&id=9c1d28ca&scoped=true&"
import script from "./ReportSectionLayout.vue?vue&type=script&lang=ts&"
export * from "./ReportSectionLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ReportSectionLayout.vue?vue&type=style&index=0&id=9c1d28ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1d28ca",
  null
  
)

export default component.exports